import { isEmpty } from 'lodash';

const hasuraClaims = 'https://hasura.io/jwt/claims';
const hasuraAllowedRolesProperty = 'x-hasura-allowed-roles';

/**
 * Parses Auth0 ID token claims into user state format
 * @param {Object} tokenInfo - ID token claims from Auth0
 * @returns {Object} Parsed user state
 */
export function parseTokenInfo(tokenInfo) {
  const { email, name, sub, __raw } = tokenInfo;
  const hasRoles = !isEmpty(tokenInfo[hasuraClaims]?.[hasuraAllowedRolesProperty]);

  return {
    isOrgOverride: tokenInfo[hasuraClaims]?.orgOverride,
    isTokenValid: true,
    user: { email, name, id: sub },
    sessionToken: __raw,
    currentOrg: tokenInfo[hasuraClaims]?.org,
    hasRoles,
    isLoading: false,
  };
}
